import { News } from "@/models/database/news/News.model";
import { create } from "zustand";

interface NewsState {
  news: News[] | null;
  loading: boolean;
  error: Error | null;
  setNews: (news: News[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: Error | null) => void;
  getNewsBySlug: (slug: string) => News | undefined;
  addNews: (newsItem: News) => void;
}

export const useNewsStore = create<NewsState>((set, get) => ({
  news: null,
  loading: true,
  error: null,
  setNews: (news) => set({ news }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  getNewsBySlug: (slug) => {
    const { news } = get();
    return news?.find((item) => item.slug === slug);
  },
  addNews: (newsItem) => {
    const { news } = get();
    set({ news: news ? [...news, newsItem] : [newsItem] });
  },
}));
